import styled from 'styled-components';
import { CarOptionStyled } from '../CarOptionStyled';
import { rem } from 'polished';

export const CarOptionStyledOV = styled(CarOptionStyled)`
    border-color: ${({ theme }) => theme.colors.grey18};

    &.isSelected,
    &:hover,
    &:focus-visible {
        border-color: ${({ theme }) => theme.colors.black};
        .inner {
            border-color: ${({ theme }) => theme.colors.black};
        }
    }

    &.isSelected {
        background: ${({ theme }) => theme.colors.grey10};
    }

    .option-card {
        &__name {
            font-size: ${({ theme }) => theme.fontSizes.textMedium};
            line-height: 1.25;
            .checkbox .checkboxWrapper label::after {
                border-color: ${({ theme }) => theme.colors.black};
                border-width: 0 3px 3px 0;
            }
        }

        &__imageWrapper {
            &.withOptionIcon {
                &::before {
                    background: unset;
                }
            }
        }
    }
`;
